/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PeriodUnitType {
    DAILY = 'DAILY',
    MONTHLY = 'MONTHLY',
    QUARTERLY = 'QUARTERLY',
    YEARLY = 'YEARLY',
}
